import { get, postFormData, postJson } from '@/utils/request'

// 资讯信息提交
export const bizConsultInfoAdd = (data) => postJson('/consult/bizConsultInfo/entry', data)
